module.exports = __webpack_public_path__ + "static/media/cert_101.8935b3bf.jpg";